import classNames from 'classnames'
import {useEffect} from 'react'
import {useSelector} from 'react-redux'

const ImgButton = ({
    type = 'submit',
    children,
    className,
    onClick,
    disabled,
    planRef,
    plans
}) => {
    const isDarkmode = useSelector(state => state.sidebar.isDarkMode)

    useEffect(() => {
        const handleClick = () => {
            if (planRef && !!plans.length) {
                planRef.current.click()
            }
        }

        handleClick()

        return () => {
            document.removeEventListener('click', handleClick)
        }
    }, [plans, planRef])

    return (
        <button
            type={type}
            onClick={onClick}
            className={classNames('img-button', {
                [className]: !!className,
                dark: isDarkmode
            })}
            disabled={disabled}
            ref={planRef}
        >
            {children}
        </button>
    )
}

export default ImgButton
